<!-- カードをグリッド上に表示するコンポーネント -->

<script setup lang="ts">
  interface Props {
    page?: number;
    totalPages?: number;
    loading?: boolean;
    emptyMessage?: string; // 空の時のメッセージ
    contentWidth: number; // FlexではなくGridで表示するのでcontentsWidthが必要。Flexでは中央揃えかつ最後の行だけ左揃えができないためGridを用いる
  }

  interface Emits {
    (event: "update:page", page: number): void;
    (event: "clickAll"): void;
    (event: "onBack"): void;
  }

  const localProps = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const computedPage = computed<number | undefined>({
    get: () => localProps.page,
    set: value => {
      emit("update:page", value || 1);
    },
  });

  const showPagination = computed<boolean>(() => {
    if (localProps.totalPages) {
      return localProps.totalPages > 1;
    }
    return false;
  });

  const gridWidth = computed<string>(() => {
    return `${localProps.contentWidth}px`;
  });

  watch(
    () => localProps.page,
    () => {
      // ページが変わったらスクロール位置をトップに戻す
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },
  );

  // レスポンシブ対応
  const isSp = isSpDisplayRef();
  const gridAlign = computed<string>(() => {
    return isSp.value ? "center" : "lest";
  });
</script>

<template>
  <v-sheet class="grid-panel my-2 mx-0 mx-sm-2" color="transparent">
    <slot></slot>
    <div v-if="emptyMessage && !loading" class="mt-8 mx-3 mx-sm-6" style="margin-bottom: 200px">
      {{ emptyMessage }}
    </div>
  </v-sheet>
  <v-sheet color="transparent" class="py-2">
    <AtomsPagination v-if="showPagination" v-model:page="computedPage" :total-pages="totalPages"> </AtomsPagination>
  </v-sheet>
</template>

<style lang="scss" scoped>
  .grid-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, v-bind(gridWidth));
    justify-content: v-bind(gridAlign);
    grid-gap: 2rem 0.81rem;
  }
</style>
